import classNames from 'classnames';
import I18n from 'i18n-js';
import { object, string } from 'prop-types';

import { TRIAL_CARD_TEMPLATE_ID } from '@lootboy/lib/config';

import LinkInternal from '~/components/LinkInternal';
import SovendusWithConsent from '~/components/Sovendus/SovendusWithConsent';

import { SEASON_TICKET_PATH } from '~/routes/paths';

import { ReactComponent as Gift } from '~/assets/images/loot-cards/gift.svg';
import { ReactComponent as Lock } from '~/assets/images/loot-cards/lock.svg';

import styles from './UriButton.module.scss';

function UriButton({ cardTemplate, country, reward, uriCode }) {
  const uriType = reward?.uriType;
  const uriForButton = uriCode ? reward?.code : reward?.uri;

  let uriButtonText;
  if (cardTemplate.uriButtonText && cardTemplate.uriButtonText !== '') {
    uriButtonText = cardTemplate.uriButtonText;
  } else {
    uriButtonText = uriCode
      ? I18n.t('RewardCodeView_codeUri_button_title')
      : I18n.t(`RewardCodeView_${uriType}_button_title`);
  }

  const isSeasonTicket =
    cardTemplate && cardTemplate._id === TRIAL_CARD_TEMPLATE_ID;

  return (
    <div className={styles.scratchCardDownload}>
      <div
        className={classNames(
          uriType === 'sovendus' ? styles.hidden : styles.scratchCardLegend,
          styles.largeOpacity,
        )}
      >
        <Lock className={styles.lockIcon} />
        <p>{I18n.t(`RewardCodeView_label_${uriCode ? 'default' : uriType}`)}</p>
        <Gift className={styles.giftIcon} />
      </div>
      {uriType === 'sovendus' ? (
        <SovendusWithConsent
          country={country}
          reward={reward}
        />
      ) : (
        <LinkInternal
          className={styles.downloadButton}
          to={isSeasonTicket ? SEASON_TICKET_PATH : uriForButton}
        >
          {uriButtonText}
        </LinkInternal>
      )}
    </div>
  );
}

UriButton.propTypes = {
  cardTemplate: object,
  country: string,
  reward: object,
  uriCode: string,
};

export default UriButton;
